import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const greetingLinesAsScenesSceneBackground = {
    variant: "plain-color",
    color: "rgba(255, 254, 242, 0.82)",
    // softens the edges of the background to make the transition less harsh
    blur: 50,
};
const images = {
    bee_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/bee_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/optimized/bee_1.webp`,
        width: 551,
        height: 435,
    },
    flower_green_2: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/flower_green_2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/optimized/flower_green_2.webp`,
        width: 146,
        height: 672,
    },
    flower_patch_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/flower_patch_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/optimized/flower_patch_1.webp`,
        width: 1920,
        height: 1048,
    },
    flower_patch_2: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/flower_patch_2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/optimized/flower_patch_2.webp`,
        width: 1920,
        height: 663,
    },
    flower_pink_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/flower_pink_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/optimized/flower_pink_1.webp`,
        width: 163,
        height: 526,
    },
    flower_red_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/flower_red_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/optimized/flower_red_1.webp`,
        width: 208,
        height: 896,
    },
    flower_yellow_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/flower_yellow_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/meadow-flowers/optimized/flower_yellow_1.webp`,
        width: 275,
        height: 617,
    },
};
export const meadowFlowers = {
    version: 1,
    themeId: "meadow-flowers",
    name: "Meadow Flowers",
    endFadeDuration: 1,
    thumbnailFrame: 100,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/meadow-flowers.webp`,
    background: [
        {
            variant: "meadow-flowers",
            color: "#fffef2",
            images: [
                {
                    src: images["flower_patch_2"],
                    enter: {
                        start: {
                            frame: 5,
                            blur: 10,
                            opacity: 0,
                            position: {
                                x: {
                                    from: "left",
                                    offset: 0,
                                },
                                y: {
                                    from: "bottom",
                                    offset: -200,
                                },
                            },
                        },
                        end: {
                            frame: 60,
                            blur: 5,
                            opacity: 1,
                        },
                    },
                    repeat: "repeat-x",
                    movePerSecond: {
                        x: -30,
                        y: 0,
                    },
                },
                {
                    src: images["flower_patch_1"],
                    enter: {
                        start: {
                            frame: 5,
                            blur: 10,
                            opacity: 0,
                            position: {
                                x: {
                                    from: "left",
                                    offset: 0,
                                },
                                y: {
                                    from: "bottom",
                                    offset: -300,
                                },
                            },
                        },
                        end: {
                            frame: 60,
                            opacity: 1,
                        },
                    },
                    repeat: "repeat-x",
                    movePerSecond: {
                        x: -60,
                        y: 0,
                    },
                },
            ],
            bees: [
                {
                    src: images["bee_1"],
                    sizeScale: 0.07,
                    movementScale: 0.5,
                    positionPercent: {
                        x: 8,
                        y: 60,
                    },
                    enter: {
                        start: {
                            frame: 5,
                            blur: 10,
                            opacity: 0,
                        },
                        end: {
                            frame: 60,
                        },
                    },
                },
                {
                    src: images["bee_1"],
                    sizeScale: 0.1,
                    movementScale: 0.5,
                    positionPercent: {
                        x: 20,
                        y: 50,
                    },
                    enter: {
                        start: {
                            frame: 5,
                            blur: 10,
                            opacity: 0,
                        },
                        end: {
                            frame: 60,
                        },
                    },
                },
                {
                    src: images["bee_1"],
                    sizeScale: 0.2,
                    movementScale: 1,
                    positionPercent: {
                        x: 45,
                        y: 40,
                    },
                    enter: {
                        start: {
                            frame: 5,
                            blur: 10,
                            opacity: 0,
                        },
                        end: {
                            frame: 60,
                        },
                    },
                },
            ],
        },
    ],
    scenes: [
        {
            type: "meadowFlowersIntro",
            durationSeconds: 9,
            faceCollage: {
                variant: "bottom-static",
                borderShape: "circle",
                borderWidth: 12,
                entrance: { variant: "fade-in", transitionDurationInFrames: 160 },
            },
            title: {
                fontFamily: "Cormorant SC",
                fontSize: 100,
                fontWeight: "light",
                textColor: "#cb6a59",
                // lowercase because the font we're using is all uppercase, but the
                // uppercase letters are bigger and so capitalization looks
                // weird/unexpected
                textTransform: "lowercase",
            },
            subtitle: {
                fontFamily: "Cormorant SC",
                fontSize: 190,
                fontWeight: "normal",
                textColor: "#cb6a59",
            },
        },
        {
            type: "greetingLinesAsScenes",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            showLogo: true,
            sceneBackground: greetingLinesAsScenesSceneBackground,
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            type: "greetingLinesAsScenes",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: greetingLinesAsScenesSceneBackground,
        },
        {
            type: "outro",
            colorVariant: "darkBlue",
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#cb6a59",
            fontFamily: "Cormorant SC",
            fontWeight: "light",
            fontSize: 90,
            leading: 1.2,
            tracking: 0,
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                entranceVariant: "slide-to-flush-left",
                startOffsetSeconds: 0.6,
                cards: [
                    {
                        backgroundColor: "#facac3",
                        backgroundOpacity: 1,
                        paddingLeft: "7rem",
                        paddingRight: "4rem",
                        doodleImages: [
                            {
                                url: images["flower_green_2"],
                                displaySize: {
                                    width: 45,
                                },
                                overflow: "hidden",
                                style: {
                                    bottom: "-50%",
                                    left: "-20px",
                                    transform: "rotate(20deg)",
                                },
                            },
                            {
                                url: images["flower_pink_1"],
                                displaySize: {
                                    width: 59,
                                },
                                overflow: "hidden",
                                style: {
                                    bottom: "0",
                                    left: "-10px",
                                    transform: "rotate(15deg)",
                                },
                            },
                            {
                                url: images["flower_yellow_1"],
                                displaySize: {
                                    width: 64,
                                },
                                overflow: "hidden",
                                style: {
                                    bottom: "-10px",
                                    left: "15px",
                                },
                            },
                            {
                                url: images["flower_red_1"],
                                displaySize: {
                                    width: 40,
                                },
                                overflow: "hidden",
                                style: {
                                    bottom: "-54%",
                                    left: "0",
                                    transform: "scaleX(-1) rotate(-20deg)",
                                },
                            },
                        ],
                    },
                ],
            },
            betweenTransition: {
                variant: "slide-fade",
                direction: "from-right",
                timing: {
                    variant: "linear",
                    easing: "easeOut",
                    durationSeconds: 1.8,
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 1,
                textColor: "#cb6a59",
                fontFamily: "Cormorant SC",
                fontWeight: "normal",
                fontSize: 70,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#fff",
                backgroundOpacity: 1,
                textColor: "#cb6a59",
                fontFamily: "Cormorant SC",
                fontWeight: "normal",
                fontSize: 40,
                nudge: 2,
                textTransform: "uppercase",
            },
            scaleFactor: 0.9,
            borderRadius: "3rem",
            boxShadow: "0.25rem 0.25rem 1.125rem 0px rgba(0,0,0,0.75)",
            border: "0.25rem solid #232626",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "slide-fade",
            direction: "from-right",
            timing: {
                variant: "linear",
                easing: "easeOut",
                durationSeconds: 1.8,
            },
        },
    },
    userInputFields: [
        {
            id: "titleMessage",
            type: "text",
            label: "Title Message",
            defaultValue: "",
            placeholder: "We will miss you!",
            required: true,
            min: 1,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 115,
            },
        },
        {
            id: "subtitleMessage",
            type: "text",
            label: "Subtitle Message",
            defaultValue: "",
            placeholder: "Jane ❤️",
            required: true,
            min: 1,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 115,
            },
        },
    ],
    colorPalettes: ["MeadowFlowers"],
};
